module.exports = __webpack_public_path__ + "img/flechas_verdes.af7fb202.webp";